import React, { useEffect, useRef, useState } from "react";
import { API_TOKEN_NAME, SCHEDULE_DATE, IMAGE_URL } from "../../constants";
import { scAxiosAdmin } from "../..";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../../images/Loading_icon.gif";
import ConfirmAppointmentAndRequestAppointment from "./ConfirmAppointmentAndRequestAppointment";
const BookAppointmentPopup = ({
  bookAppointmentPopupClicked,
  setBookAppointmentPopupClicked,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [loading, setLoading] = useState(false);
  const [fromNav, setFromNav] = useState(false);
  const [scheduleReqData, setScheduleReqData] = useState({
    DoctorID: "",
    PreferredDate: "",
    doctorData: "",
  });
  const [formData, setFormData] = useState({
    selectedDepartment: "all",
    searchedText: "",
  });

  // const formatedDoc = doctorData && doctorData.doctor_name.toLowerCase();
  const alertStyle = {
    color: "red",
  };
  const inputStyles = {
    borderRadius: "10px",
    background: "#fff",
    borderRight: "solid 1px #fff",
    border: "solid 2px #6e6e6ed0",
    padding: "15px 15px",
    fontSize: "16px",
    color: "#000",
    width: "100%",
  };
  let filteredData = null;
  useEffect(() => {
    const getSearchDoctors = (data) => {
      try {
        setLoading(true);
        const req = scAxiosAdmin
          .request("/search/find_a_doctor", {
            method: "get",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
            params: {
              keyword: formData.searchedText,
              deparment: formData.selectedDepartment,
            },
          })
          .then((data) => {
            if (data.status === 200) {
              setLoading(false);
              setSearchResults(data.data.doctors);
            }
          })
          .catch((e) => {
            setLoading(false);
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getSearchDoctors();
  }, [
    formData.searchedText,
    departmentId,
    filteredData,
    bookAppointmentPopupClicked,
  ]);

  useEffect(() => {
    setDepartmentId(formData.selectedDepartment);
  }, [formData.selectedDepartment]);

  const handleSubmit = (event, props) => {
    event.preventDefault();
  };

  return (
    <div>
      <div
        class="offcanvas offcanvas-start bookAppointPopup"
        data-bs-scroll="true"
        tabindex="-1"
        id="BookAppointMent"
        aria-labelledby="offcanvasWithBothOptionsLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel"></h5>
          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            // onClick={() => setBookAppointmentPopupClicked(false)}
          ></button>
        </div>
        <div class="offcanvas-body">
          <div className="left-offcanvas">
            <div className="offcan-top-mar">
              <h4 style={{ color: "#af9763" }}>Book Appointment</h4>
              {/* <p>Enter Doctor's Name</p> */}
            </div>

            <form
              onSubmit={handleSubmit}
              className="needs-validation"
              noValidate
            >
              <input
                type="text"
                style={inputStyles}
                className="custom-form-control"
                placeholder="Search With Doctors Name..."
                name="searchTerm"
                id="searchTerm"
                value={formData.searchedText}
                onChange={(e) =>
                  setFormData({ ...formData, searchedText: e.target.value })
                }
                required
                autoComplete="off"
                // style={input_field_css}
              />
              <span style={alertStyle}></span>
              <div className="row mt-3">
                <span style={alertStyle}></span>
                {searchResults && searchResults.length > 0 ? (
                  searchResults.slice(0, 3).map((search_doctor) => (
                    <div className="col-12 sp-0-0 mb-3" key={search_doctor.id}>
                      <div className="doctor-list">
                        <input
                          type="radio"
                          className="doctor_id"
                          name="doctor_id"
                          value={search_doctor.id}
                          onChange={() =>
                            setScheduleReqData({
                              ...scheduleReqData,
                              DoctorID: search_doctor.id,
                              doctorData: search_doctor,
                            })
                          }
                          doctorName={search_doctor.doctor_name}
                          deptid={search_doctor.dept_id}
                        />
                        <div className="row">
                          <div className="col-3" style={{ paddingLeft: "0px" }}>
                            {search_doctor.doctor_profile ? (
                              <img
                                style={{ borderRadius: "10px" }}
                                src={
                                  IMAGE_URL +
                                  "DoctorProfileImg/" +
                                  search_doctor.doctor_profile
                                }
                                alt="doctor profile"
                              />
                            ) : (
                              /*<img src={doc} alt="doc"/>*/
                              <img
                                src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                                alt="doc"
                              />
                            )}
                          </div>
                          <div className="col-9 mt-2">
                            <h5>{search_doctor.doctor_name}</h5>
                            <p>
                              {search_doctor.degree !== ""
                                ? search_doctor.degree
                                : "Endocrinology & Metabolism) MD (Endocrinology & Metabolism)"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 sp-0-0 mb-3">
                    {loading ? (
                      <img src={Loading} alt="Loading" />
                    ) : (
                      <p style={{ color: "red" }}>No results found!</p>
                    )}
                  </div>
                )}
              </div>
              <div className="row mt-3">
                <div className="col-6">
                  {/* if modal backdrop need to be visible on after nav just uncomment the css in style.css .modal-backdrop.show in line around 3638 */}
                  <input
                    type="date"
                    id="schedule_date"
                    name="schedule_date"
                    className="customDatePicker"
                    onChange={(e) =>
                      setScheduleReqData({
                        ...scheduleReqData,
                        PreferredDate: e.target.value,
                      })
                    }
                    placeholder="DD-MM-YYYY"
                    defaultValue={localStorage.getItem(SCHEDULE_DATE)}
                    required
                  />

                  {/* <DatePicker
                      id="schedule_date"
                      name="schedule_date"
                      className="customDatePicker"
                      autoComplete="off"
                      //   selected={state.selectedDate}
                      //   onChange={handleDateChange}
                      // selected={rawDate}
                      // value={rawDate}
                      // onChange={(date) => handleDateChange(date)}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      showDateMonthYearPicker
                    /> */}
                  {/* <span style={alertStyle}>{state.errors.schedule_date}</span> */}
                </div>
                <div className="col-6">
                  {/*<a href={site_url+'/index3'} className="btn-links" id="Schedule">Check Schedule</a>*/}
                  <button
                    variant="primary"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#confirmAppointmentOffcanvas"
                    aria-controls="confirmAppointmentOffcanvas"
                    style={{
                      backgroundColor: !scheduleReqData.PreferredDate
                        ? ""
                        : "rgb(246, 130, 31)",
                    }}
                    type="submit"
                    id="Schedule"
                    className="btn-links"
                    disabled={!scheduleReqData.PreferredDate ? true : false}
                  >
                    Check Schedule
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ConfirmAppointmentAndRequestAppointment
        scheduleReqData={scheduleReqData}
      ></ConfirmAppointmentAndRequestAppointment>
    </div>
  );
};

export default BookAppointmentPopup;



// WEBPACK FOOTER //
// ./src/component/frontend/BookAppointmentPopup.js